import script from "./PresetShop.vue?vue&type=script&setup=true&lang=js"
export * from "./PresetShop.vue?vue&type=script&setup=true&lang=js"

import "./PresetShop.vue?vue&type=style&index=0&id=247dabe0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-247dabe0"]])

export default __exports__